import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import CircularProgress from "@mui/material/CircularProgress";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../../css/Login.css";
import forgotPwdImage from "../../assets/Forgot Password 1.png";
import LoginSubmitWhiteIcon from "../../assets/Icons/RegisterLoginIconOrange.png";
import encryptAES from "../../helpers/encryption";

const SetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const usernameFromUrl = searchParams.get("username");
  const [username, setUsername] = useState(usernameFromUrl || "");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // Submit New Password
  const handlePasswordSubmit = (event) => {
    event.preventDefault();

    if (newPassword !== confirmPassword) {
      CustomAlert({
        title: "Password Mismatch",
        text: "New Password and Confirm Password do not match.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      return;
    }

    setLoading(true);
    const encryptedUsername = encryptAES(username);
    const encryptedPassword = encryptAES(newPassword);
    const encryptedConfirmPassword = encryptAES(confirmPassword);

    const data = {
      username: encryptedUsername,
      otp,
      password: encryptedPassword,
      confirmPassword: encryptedConfirmPassword,
    };

    axiosPostApi(apiList.UPDATE_PASSWORD, data)
      .then((response) => {
        const message =
          response?.data?.message || "Password updated successfully";

        if (response?.data?.data === null) {
          CustomAlert({
            title: "Success",
            text: message,
            icon: "success",
            confirmButtonText: "Login",
          }).then(() => {
            navigate("/");
          });
        } else {
          CustomAlert({
            title: "Failed",
            text: message,
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error.response || error.message);
        CustomAlert({
          title: "Error",
          text: "An error occurred while updating the password. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="container-fluid">
      <div className="row align-items-center login-container">
        {/* Form Section */}
        <div className="login-form-parent col-md-6 d-flex flex-column justify-content-center">
          <p>
            Access Your Account{" "}
            <span style={{ fontWeight: "400" }}>to Get Started</span>
          </p>
          <form onSubmit={handlePasswordSubmit}>
            <div className="login-form-main-division form-floating">
              <div
                className="form-floating mb-3"
                style={{ position: "relative" }}
              >
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control login-inputs"
                  placeholder="New Password"
                  id="newPassword"
                  value={newPassword}
                  onChange={(event) => setNewPassword(event.target.value)}
                />
                <label htmlFor="newPassword">New Password</label>
                <span onClick={toggleShowPassword} className="showpwd-eye">
                  {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                </span>
              </div>

              <div className="form-floating mb-3">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control login-inputs"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(event) => setConfirmPassword(event.target.value)}
                />
                <label>Confirm Password</label>
                <span onClick={toggleShowPassword} className="showpwd-eye">
                  {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                </span>
              </div>
            </div>

            <div className="login-btn-container">
              <button type="submit" className="btn loginNow-btn">
                {loading ? (
                  <CircularProgress
                    className="circular-loader"
                    style={{ width: "20px", height: "20px" }}
                  />
                ) : (
                  <span className="login-text">Submit</span>
                )}
              </button>
              <span className="login-icon">
                <img src={LoginSubmitWhiteIcon} alt="SubmitIcon" className="h-[50px]" />
              </span>
            </div>
          </form>
        </div>

        {/* Image Section */}
        <div className="col-md-6 d-none d-md-block login-image">
          <img className="img-fluid" src={forgotPwdImage} alt="Set Password" />
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
